import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import config from '../../config';
import './HeaderBar.scss';

const HeaderBar = (props) => {
  const { i18n, type, enableSSO, enableTSSSO } = props;
  const { translations = {}, locale } = i18n || {};
  const { header_bar = {} } = translations[locale] || {};
  const {
    link_home = {},
    link_about = {},
    title_login = '',
    title_logout = '',
    title_edit_profile = '',
    title_register = '',
    title_myhktdc = '',
    link_myhktdc,
  } = header_bar;

  const [SSOStatus, setSSOStatus] = useState(false);

  useEffect(() => {
    console.log(enableTSSSO, enableSSO);
    if (enableTSSSO && enableSSO.status === true) {
      // if (window.sso) {
      //   setSSOStatus(window.sso.client.getAccessToken() || false);
      //   console.log('SSOStatus', SSOStatus);
      // }
      setSSOStatus(enableSSO.status);
    } else {
      setSSOStatus(false);
    }
  }, [enableTSSSO, enableSSO]);

  const _getSSOLangCode = () => {
    const lang = i18n.locale;
    return config.sso_lang_map[lang];
  };

  const handleLoginClick = (e) => {
    e.preventDefault();
    if (window.ssoClient) {
      window.ssoClient.login({
        lang: _getSSOLangCode(),
        redirect_uri: window.location.href,
      });
    }
  };

  const handleEditProfileClick = async (e) => {
    e.preventDefault();
    if (window.ssoClient) {
      await window.ssoClient.accessProfile({
        lang: _getSSOLangCode(),
        newWindow: 'true',
      });
    }
  };

  const handleLogoutClick = async (e) => {
    e.preventDefault();
    if (window.ssoClient) {
      await window.ssoClient.logout(window.location.href);
    }
  };

  const handleRegisterClick = (e) => {
    e.preventDefault();
    if (window.ssoClient) {
      window.ssoClient.register({
        lang: _getSSOLangCode(),
        redirect_uri: window.location.href,
      });
    }
  };

  // const getSSODisplayName = () => {
  //   let fullName = '';
  //   if (window.sso) {
  //     fullName = `$(window.sso.client.getUserFirstName()} ${window.sso.client.getUserLastName()}`;
  //   }
  //   return fullName;
  // };

  // const getSSOUserFirstName = () => {
  //   return window.sso && window.sso.client.getUserFirstName();
  // };

  // const getSSOUserLastName = () => {
  //   return window.sso && window.sso.client.getUserLastName();
  // };

  const ssoClassName =
    type === 'HeaderTop'
      ? 'sso-links hideTablet'
      : 'sso-links hideNonTablet menuheaderlinksContainer';

  const myHKTDCHTML = enableTSSSO && (
    <a href={link_myhktdc} className="" target="_blank" rel="noopener noreferrer">
      {title_myhktdc}
    </a>
  );

  const headerTop = () => {
    return (
      <div className="header-bar hideTablet">
        <a href={link_home.url} target="_blank" rel="noopener noreferrer">
          {link_home.name}
        </a>
        <a href={link_about.url} target="_blank" rel="noopener noreferrer">
          {link_about.name}
        </a>
        {myHKTDCHTML}
      </div>
    );
  };

  const mainMenu = () => {
    return (
      <div className="hideNonTablet menuheaderlinksContainer">
        <a href={link_home.url} className="" target="_blank" rel="noopener noreferrer">
          {link_home.name}
        </a>
        <a href={link_about.url} className="" target="_blank" rel="noopener noreferrer">
          {link_about.name}
        </a>
        {myHKTDCHTML}
      </div>
    );
  };

  const SSOButtonsHTML = SSOStatus ? (
    <span className={ssoClassName}>
      <span className="top-bar__icon top-bar__icon--login"></span>
      <span
        className="top-bar__txt"
        tabIndex="0"
        onClick={handleEditProfileClick.bind(this)}
        onKeyPress={handleEditProfileClick.bind(this)}
      >
        {title_edit_profile}
      </span>
      &nbsp;&nbsp;&nbsp;
      <span
        className="top-bar__txt"
        tabIndex="0"
        onClick={handleLogoutClick.bind(this)}
        onKeyPress={handleLogoutClick.bind(this)}
      >
        {title_logout}
      </span>
    </span>
  ) : (
    <span className={ssoClassName}>
      <span className="top-bar__icon top-bar__icon--login"></span>
      <span
        className="top-bar__txt"
        tabIndex="0"
        onClick={handleLoginClick.bind(this)}
        onKeyPress={handleLoginClick.bind(this)}
      >
        {title_login}
      </span>{' '}
      /{' '}
      <span
        className="top-bar__txt"
        tabIndex="0"
        onClick={handleRegisterClick.bind(this)}
        onKeyPress={handleRegisterClick.bind(this)}
      >
        {title_register}
      </span>
    </span>
  );

  return (
    <>
      {type === 'HeaderTop' && headerTop()}
      {type === 'MainMenu' && mainMenu()}

      {enableTSSSO && SSOButtonsHTML}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  enableSSO: state.enableSSO,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(HeaderBar);

export { HeaderBar as HeaderBarComponent }; // <- For component Unit Test
export default connectStore;
